
import httpClientHub from '@/libs/http-client-hub'

export function getScrollDataByHub (params) {
  const url = '/v1/heatmap/analytics/scroll'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getScrollDataByHub error:', error)
    return error
  })
}

export function getAIReportData (params) {
  const url = '/v1/heatmap/ai/report_data'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getAIReportData error:', error)
    return error
  })
}

export function createCXReport (params) {
  const url = '/v1/heatmap/ai/create_ai_report'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('createCXReport error:', error)
    return error
  })
}

export function getCXReport (params) {
  const url = '/v1/heatmap/ai/get_ai_report'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getCXReport error:', error)
    return error
  })
}

export function getReplayData (params) {
  const url = '/v1/heatmap/replay'

  // params
  // {
  //   "aid": "62d8a7546af1f06f28905183",
  //   "device": "phone",
  //   "interval": 1,
  //   "startDate": "2025-02-11T12:00:00",
  //   "endDate": "2025-02-11T12:30:00"
  // }

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getReplayData error:', error)
    return error
  })
}

// Time Machine
export function getTimeMachineList (params) {
  const url = '/v1/heatmap/time_machine/get_list'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getTimeMachineList error:', error)
    return error
  })
}

export function getTimeMachineReport (params) {
  const url = '/v1/heatmap/time_machine/get_report'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getTimeMachineReport error:', error)
    return error
  })
}

export function addTimeMachine (params) {
  const url = '/v1/heatmap/time_machine/add'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('addTimeMachine error:', error)
    return error
  })
}

export function modifyTimeMachine (params) {
  const url = '/v1/heatmap/time_machine/modify'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('modifyTimeMachine error:', error)
    return error
  })
}

export function deleteTimeMachine (params) {
  const url = '/v1/heatmap/time_machine/delete'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('deleteTimeMachine error:', error)
    return error
  })
}

export function getReplay (params) {
  const url = '/v1/heatmap/replay/get_replay'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getReplay error:', error)
    return error
  })
}

export function getApplyCoords (params) {
  const url = '/v1/heatmap/apply/get_coords'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getApplyCoords error:', error)
    return error
  })
}

export function getTopEvent (params) {
  const url = '/v1/heatmap/replay/get_top_event'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getTopEvent error:', error)
    return error
  })
}

export function getTimeMachineReportExists (params) {
  const url = '/v1/heatmap/time_machine/check_today_exists'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getTimeMachineReportExists error:', error)
    return error
  })
}

export function createTimeMachineReport (params) {
  const url = '/v1/heatmap/replay/create_report_data'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('createTimeMachineReport error:', error)
    return error
  })
}

export function getBasicInfo (params) {
  const url = '/v1/heatmap/analytics/get_basic_info'

  return httpClientHub.post(url, params).then(response => {
    return response.data
  }).catch(error => {
    console.log('getBasicInfo error:', error)
    return error
  })
}
